export default __webpack_public_path__ + "static/media/tensorflow-layout.fd509e60.svg";